exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-heart-icon.ebx-icon--filled>g{fill:currentColor}", ""]);
